module.exports = __webpack_public_path__ + "static/media/FlagNorway.8a1c7aed.svg";